import { Injectable } from "@angular/core";
import { HttpService } from "./http.service";

@Injectable({
  providedIn: "root",
})
export class ErrorService {
  constructor(private _httpService: HttpService) {}

  public report(context: string, error: unknown): void {
    const serializedError = this._serializeError(error);
    this._httpService.post("/v2/frontend-errors", { context, error: serializedError }).subscribe({
      error: () => {
        // Fire-and-forget: reporting must not affect the user flow.
      },
    });
  }

  private _serializeError(error: unknown): string {
    if (typeof error === "string") {
      return error.slice(0, 500);
    }

    if (error instanceof Error) {
      return error.message.slice(0, 500);
    }

    try {
      return JSON.stringify(error).slice(0, 500);
    } catch {
      return String(error).slice(0, 500);
    }
  }
}
